import { type FC } from 'react'

import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service'

import { CrossSellProductCard } from '../../../cross-sell/components/CrossSellProductCard'
import { useGlobalConfigContext } from '../../../global-config/context/globalConfigContext'
import {
  EXPERIMENTS_TRACK_EVENT_PDP_CSW_PRODUCT,
  experimentsTrackEvent,
} from '../../eventTracking'

export const ExperimentCrosssellLayoutSliderItem: FC<{
  product?: CrossSellProduct
}> = ({ product }) => {
  const config = useGlobalConfigContext()

  return (
    <CrossSellProductCard
      onClick={() => {
        experimentsTrackEvent(config, EXPERIMENTS_TRACK_EVENT_PDP_CSW_PRODUCT)
      }}
      product={product}
    />
  )
}
